import React from 'react';
import styled from 'styled-components';
import { DocumentManagement } from 'Components/SuperAdminPage/SuperAdminContentManagement';
import { SuperAdminLayout } from 'Components/Layout/SuperAdminLayout';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;

const AdminEducations = () => {
  return (
    <SuperAdminLayout>
      <ContentContainer>
        <DocumentManagement />
      </ContentContainer>
    </SuperAdminLayout>
  );
};
export default AdminEducations;
